module.exports = __webpack_public_path__ + "img/repeat-08.9b652cad.svg";